module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"gl":{"unlimited":"Ilimitado","time":"Máximo Tempo en Coche:"},"es":{"unlimited":"Ilimitado","time":"Máximo Tiempo en Coche:"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/filter/FilterDistancia.vue
// module id = 130
// module chunks = 0